module.exports = __webpack_public_path__ + "img/page_cam_slider_01.055d7d1b.png";